import * as Sentry from "@sentry/browser";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import { useEffect } from "react";
import { reactRouterV6Instrumentation } from "@sentry/react";

type SentryConfiguration = {
  dsn: string;
  environment: string;
  version: string;
};

export async function initializeSentry() {
  const sentryConfigurationResponse = await fetch("/api/sentry");
  if (sentryConfigurationResponse.ok) {
    const sentryConfiguration: SentryConfiguration =
      await sentryConfigurationResponse.json();
    Sentry.init({
      dsn: sentryConfiguration.dsn,
      environment: sentryConfiguration.environment,
      release: sentryConfiguration.version,
      integrations: [
        new Sentry.BrowserTracing({
          routingInstrumentation: reactRouterV6Instrumentation(
            useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes
          ),
        }),
      ],
    });
  }
}
